import { InputType } from "@app/enum/input-type";

export class QuestionBase<T> {
    value: T | undefined;
    placeholder: string;
    key: string;
    label: string;
    required: boolean;
    order: number;
    controlType: string;
    helpText: string;
    type: InputType;
    patternValidator: string | null;
    options: InputOption[];
    errorText: string;
    minLength: number;
    maxLength: number;
    phoneMask: boolean;
    numberOnly: boolean;
    search: boolean;
    width: string;
    externalFunction: string;
    disable: boolean;

    constructor(
      options: {
        value?: T;
        placeholder?: string,
        key?: string;
        label?: string;
        required?: boolean;
        order?: number;
        controlType?: string;
        helpText?: string
        type?: InputType;
        patternValidator? : string;
        options?:  InputOption[];
        errorText?:  string;
        minLength?: number;
        maxLength?: number;
        phoneMask?: boolean;
        numberOnly?: boolean;
        width?: string;
        search?: boolean;
        externalFunction?: string;
        disable?: boolean;
      } = {},
    ) {
      this.value = options.value;
      this.key = options.key || '';
      this.placeholder = options.placeholder || '';
      this.label = options.label || '';
      this.required = !!options.required;
      this.order = options.order === undefined ? 1 : options.order;
      this.controlType = options.controlType || '';
      this.type = options.type || InputType.TEXT;
      this.helpText = options.helpText || '';
      this.patternValidator = options.patternValidator || null;
      this.options = options.options || [];
      this.errorText = options.errorText || '';
      this.minLength = options.minLength || 0;
      this.maxLength = options.maxLength || 99999;
      this.phoneMask = options.phoneMask || false;
      this.width = options.width || 'md:w-1/2 lg:w-1/2';
      this.numberOnly = options.numberOnly || false;
      this.search = options.search || false;
      this.externalFunction = options.externalFunction || '';
      this.disable = options.disable || false;
    }
  }